import React from 'react';
import GetSvg from '../../vendor/GetSvg';
import getSealIcon from './sealIcons';

const SealRow = ({ name, sealKey, isAchieved }) => (
  <li
    className={`seal-row${isAchieved ? ' seal-row--achieved' : ''}`}
    key={sealKey}>
    <div className="seal-row__pill">
      <span className="seal-row__name">{name}</span>
      <GetSvg
        svg={isAchieved ? 'seal_unlock' : 'seal_lock'}
        wrapperClass="svg seal-row__lock"
      />
    </div>
    <div className="seal-row__icon">
      <GetSvg
        svg={getSealIcon(sealKey, isAchieved)}
        wrapperClass="svg seal-row__icon-art"
      />
    </div>
  </li>
);

export default SealRow;
